// extracted by mini-css-extract-plugin
export default {"productDescription":"Hda-z","featuredDescription":"Ida-z","description":"Jda-z","more":"Kda-z","descriptionSku":"Lda-z"};